<template>
  <!-- 群蜂 Banner 广告（独立组件，不走 Adver.vue） -->
  <div class="qunfeng-banner" :id="containerId"></div>
</template>
<script>
import { getAdPositionId } from '../../../config/adConfig'

let bannerCounter = 0

export default {
  name: 'QunfengBanner',
  data () {
    return {
      containerId: 'qunfeng-banner-' + (++bannerCounter)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadAd()
    })
  },
  methods: {
    loadAd () {
      const positionId = getAdPositionId('HOME_BANNER')
      if (!positionId) {
        console.warn('[QunfengBanner] HOME_BANNER 未配置群蜂广告位')
        return
      }
      if (typeof window.qfAd === 'undefined') {
        console.error('[QunfengBanner] SDK未加载，请确保已引入 ad.min.js')
        return
      }

      const sid = this.$store.state.sid.sid || ''
      console.log('[QunfengBanner] 加载, positionId:', positionId, 'sid:', sid)

      try {
        // eslint-disable-next-line no-new, new-cap
        new window.qfAd({
          containerId: this.containerId,
          positionId: positionId,
          projeckNo: sid
        })
        this.watchAdClose()
      } catch (err) {
        console.error('[QunfengBanner] 加载失败', err)
      }
    },
    // 检测广告被关闭（SDK隐藏或清空广告内容）
    // MutationObserver 是事件驱动的，DOM 不变时零开销
    watchAdClose () {
      const self = this
      const container = document.getElementById(this.containerId)
      if (!container) return

      function checkVisible () {
        const all = container.querySelectorAll('*')
        for (let i = 0; i < all.length; i++) {
          const el = all[i]
          const cs = window.getComputedStyle(el)
          if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') continue
          if (el.offsetWidth > 0 && el.offsetHeight > 0) return true
        }
        return false
      }

      const observer = new MutationObserver(function () {
        if (!checkVisible()) {
          observer.disconnect()
          console.log('[QunfengBanner] 广告已关闭，通知父组件')
          self.$emit('ad-closed')
        }
      })
      observer.observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      })
    }
  }
}
</script>
<style scoped>
.qunfeng-banner {
  min-height: 50px;
  position: static !important;
}
.qunfeng-banner [id^="containAd-"] {
  position: static !important;
}
</style>
